import { useContext } from 'react';

import { AppContext } from '../scripts/context'

export default function Scrollbar() {

    const {
    //SCROLL
        scrollbarState,
    //STYLE
        scrollbarStyleState,
        scrollbarSliderStyleState,
    } = useContext(AppContext);

    return (
        <div id="scrollbar" style={scrollbarStyleState}>
            {scrollbarState ?
                <div id="scrollbar_slider" style={scrollbarSliderStyleState}></div>
                :
				null
            }
        </div>
    );

};